import { config, sleep } from "./helpers";

export async function rpc(fn, payload, meta = {}) {
  const { dev, functionsUrl } = config();

  if (dev) {
    // const duration = Math.floor(Math.random() * 2000);
    // console.info(`adding dev latency: ${duration}ms`);
    // await sleep(duration);
  }

  const r = await fetch(`${functionsUrl}/rpc/${fn}`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify({
      fn,
      payload,
      ...meta
    }),
  });

  if (!r.ok) throw new Error(r.statusText);
  const data = await r.json();


  if (data.success === true) return data.payload;
  const err = new Error(data.error.message);
  err.stack = data.error.stack;
  err.code = data.error.code;
  err.name = data.error.name;
  throw err;
}

export async function getPageState(token) {
  const { apiUrl } = config();

  const r = await fetch(`${apiUrl}/digest-report/${token}`);
  if (!r.ok) throw new Error(r.statusText);
  return await r.json();
}